import type { NavContext } from '../layout/navigation';
import { isBackOffice } from '../layout/navigation';

// Einführung beim ersten Login: Schritte je Rolle (Telefonakquise, Büro, Außendienst, Leitung).

export interface TourStep {
  title: string;
  text: string;
}

// tourEvent: öffnet die Einführung erneut (z. B. aus der KI-Hilfe).
export const tourEvent = 'em:welcome';
export const tourStorageKey = (userId: string) => `em.welcome.v1.${userId}`;

export function tourSteps(c: NavContext): TourStep[] {
  const steps: TourStep[] = [
    {
      title: 'Willkommen bei Maklerpass',
      text: 'Hier arbeiten Sie vom Lead bis zum Termin beim Makler. In einer Minute zeigen wir Ihnen, wo Sie was finden – links im Menü stehen nur die Bereiche, die Sie brauchen.',
    },
  ];
  if (c.fieldOnly) {
    steps.push(
      {
        title: 'Ihr Tag',
        text: 'Auf „Heute“ sehen Sie Ihre Termine mit Route und Fahrzeiten. „Navigation starten“ öffnet die Adresse direkt in der Karten-App.',
      },
      {
        title: 'Rückfragen an das Büro',
        text: 'Unter „Rückfragen“ klären Sie Fragen zu Terminen mit dem Support. Einen Termin, den Sie nicht wahrnehmen können, geben Sie in der Terminansicht zurück.',
      },
    );
  }
  if (!c.fieldOnly && c.can('call.start')) {
    steps.push(
      {
        title: 'Akquise',
        text: '„Nächster Lead“ (Taste N) holt immer den wichtigsten Anruf: erst vereinbarte Rückrufe, dann Wiedervorlagen, dann neue Leads. Die Schrittleiste zeigt, wo Sie gerade stehen.',
      },
      {
        title: 'Termine fair vereinbaren',
        text: 'Kündigen Sie den Makler ausdrücklich an, fassen Sie den Termin zusammen und holen Sie ein klares Ja ein – nie überreden. Die Live-Hilfe erinnert Sie im Gespräch daran.',
      },
    );
  }
  if (isBackOffice(c)) {
    steps.push({
      title: 'Posteingang',
      text: 'Rückfragen, Rückrufe, Termine ohne Makler und unklare Adressen liegen gesammelt im „Posteingang“ – oben nach Gebiet und Makler filtern.',
    });
  }
  if (!c.fieldOnly && (c.can('call.review') || c.can('project.manage'))) {
    steps.push({
      title: 'Führung',
      text: '„Gespräche“ zeigt wiederkehrende Einwände und die Terminquote. Unter „Verwaltung“ stellen Sie Anrufzeiten, Gesprächsleitfaden und Projektmitglieder ein.',
    });
  }
  steps.push({
    title: 'KI-Hilfe',
    text: 'Oben rechts „KI-Hilfe“: Fragen Sie zu jeder Seite, wie etwas geht – die KI erklärt es Schritt für Schritt. Dort können Sie auch diese Einführung erneut ansehen.',
  });
  return steps;
}
